import axios from "axios";
import store from "./store";

const http = axios.create({
  baseURL: process.env.VUE_APP_API_ENDPOINT,
  timeout: 30000,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  }
});

http.interceptors.request.use(
  config => {
    // add authorization token if logged in
    if (store.getters.isAuthenticated) {
      config.headers.common["Authorization"] =
        "Bearer " + store.getters.sessionToken;
    }

    // add timezone
    config.headers.common["timezone"] = !isNaN(
      store.getters.preferences.timezone
    )
      ? store.getters.preferences.timezone
      : -3;

    // add language preference
    if (store.getters.locale) {
      config.headers["locale"] = store.getters.locale;
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

export default http;
